/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { CreditAppSavedSectionInfo } from '../../../apollo/fragments/CreditAppSavedSectionInfo.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateBusinessAddress_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_physicalAddress_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly street: string | null, readonly streetAdditional: string | null, readonly city: string | null, readonly state: string | null, readonly countryCode: string | null, readonly postalCode: string | null };

export type UpdateBusinessAddress_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_mailingAddress_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly street: string | null, readonly streetAdditional: string | null, readonly city: string | null, readonly state: string | null, readonly countryCode: string | null, readonly postalCode: string | null };

export type UpdateBusinessAddress_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly mailingPhysicalAddressesEqual: boolean | null, readonly physicalAddress: UpdateBusinessAddress_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_physicalAddress_CreditApplicationAddress | null, readonly mailingAddress: UpdateBusinessAddress_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_mailingAddress_CreditApplicationAddress | null };

export type UpdateBusinessAddress_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type UpdateBusinessAddress_updateCreditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly businessInfo: UpdateBusinessAddress_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null, readonly savedSectionsInfo: ReadonlyArray<UpdateBusinessAddress_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export type UpdateBusinessAddress_Mutation = { readonly __typename: 'Mutation', readonly updateCreditApplication: UpdateBusinessAddress_updateCreditApplication_CreditApplication };


export type UpdateBusinessAddressVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  businessInfo: _Types.BusinessInfoInput;
}>;


export type UpdateBusinessAddress = UpdateBusinessAddress_Mutation;


export const UpdateBusinessAddressDocument = gql`
    mutation UpdateBusinessAddress($creditApplicationId: ID!, $businessInfo: BusinessInfoInput!) {
  updateCreditApplication(
    creditApplicationId: $creditApplicationId
    businessInfo: $businessInfo
  ) {
    salesforceCreditId
    fetchedAt
    businessInfo {
      mailingPhysicalAddressesEqual
      physicalAddress {
        street
        streetAdditional
        city
        state
        countryCode
        postalCode
      }
      mailingAddress {
        street
        streetAdditional
        city
        state
        countryCode
        postalCode
      }
    }
    ...CreditAppSavedSectionInfo
  }
}
    ${CreditAppSavedSectionInfo}`;
export type UpdateBusinessAddressMutationFn = Apollo.MutationFunction<UpdateBusinessAddress, UpdateBusinessAddressVariables>;

/**
 * __useUpdateBusinessAddress__
 *
 * To run a mutation, you first call `useUpdateBusinessAddress` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAddress` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAddress, { data, loading, error }] = useUpdateBusinessAddress({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      businessInfo: // value for 'businessInfo'
 *   },
 * });
 */
export function useUpdateBusinessAddress(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAddress, UpdateBusinessAddressVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessAddress, UpdateBusinessAddressVariables>(UpdateBusinessAddressDocument, options);
      }
export type UpdateBusinessAddressHookResult = ReturnType<typeof useUpdateBusinessAddress>;
export type UpdateBusinessAddressMutationResult = Apollo.MutationResult<UpdateBusinessAddress>;
export type UpdateBusinessAddressMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAddress, UpdateBusinessAddressVariables>;